import { IEventLoggingComponentProps, useEventLogging, withEventLogging } from '@AppModels/Logging';
import { KeyDateKind, ScheduleCriteria } from '@ViewModels';
import { css, StyleDeclarationValue } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { toast } from 'sonner';
import { Button } from '../../../components-v2/Button';
import { ScheduleSendIcon } from '../../svgs/icons/ScheduleSendIcon';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps {
	className?: string;
	header?: string;
	keyDateKind?: KeyDateKind;
	message?: string;
	onShowOmitConfirmation?(): void;
	onScheduleClicked?: (criteria: ScheduleCriteria, startDate: Date) => Promise<void> | void;
	styles?: StyleDeclarationValue[];
}

const KeyDateSendOptionsSFC: React.FC<IProps> = props => {
	const { className, styles, keyDateKind, onShowOmitConfirmation, onScheduleClicked, logInput, message, header } =
		props;
	const { logApiError } = useEventLogging('KeyDateSendOptions');
	const [loading, setLoading] = React.useState<boolean>(false);

	const schedule = async () => {
		if (onShowOmitConfirmation) {
			onShowOmitConfirmation();
		} else {
			// we only care about the time of the day portion
			setLoading(true);
			const date = moment().utc().startOf('day').add(9, 'hours').toDate();

			logInput('Schedule', 'Click');
			try {
				await onScheduleClicked?.(ScheduleCriteria.OnDayOf, date);
			} catch (error) {
				toast.error('Error scheduling email');
				logApiError('KeyDateEmailSend-Error', error);
			}
			setLoading(false);
		}
	};

	return (
		<div className={`${css(styleSheet.container, ...(styles || []))} key-date-send-options ${className || ''}`}>
			<ScheduleSendIcon />
			<div className={css(styleSheet.body)}>
				<div className={css(styleSheet.title)}>
					<div>{header || `Schedule Send for ${keyDateKind}`}</div>
				</div>
				<div className={css(styleSheet.message)}>
					{message ||
						`Since we send these emails individually, we are able to send these emails on the actual day of the recipient’s ${keyDateKind}.`}
				</div>
				<Button styles={[styleSheet.scheduleButton]} disabled={loading} onClick={schedule} isLoading={loading}>
					Schedule it
				</Button>
			</div>
		</div>
	);
};

export const KeyDateSendOptions = withEventLogging(KeyDateSendOptionsSFC, 'KeyDateSendOptions');
